module.exports = __webpack_public_path__ + "14e62b8b4012c3e6c88c672fc4b668ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/pff-icn-clr.png
// module id = 1761
// module chunks = 0